export const ApplicationEN = {
    "administrative":"Administrative",
    "myApplication":"My application",
    "myApproval":"My approval",
    "myDepartment":"My department",
    "forSomeElse":"For some else",
    "inout":"Check in/check out",
    "absence":"Absence",
    "resign":"Resign",
    "shiftSwap":"Shift swap",
    "missions":"Mission",
    "overtime":"Overtime",
    "shiftMore":"Shift more",
    "flexible":"Flexible",
    "leave":"Leave",
    "shiftRegistration":"Shift Registration",
    "late": "Late/Early"
}